import React from 'react';
import { useSearchParams } from 'react-router-dom';
import type { OutreachWorkspaceContactStatus } from 'fym-shared/src/music24/outreach/types';
import { TypedMemo } from '../../../common/types';
import { LoadingView } from '../../../common/views/LoadingView';
import { useAccountId } from '../../../../redux/slices/appInfo/hooks';
import { ContactsScreen } from './ContactsScreen';

const STATUSES: readonly OutreachWorkspaceContactStatus[] = ['new', 'pitched', 'replied', 'placed', 'doNotContact'];

/** The route `/outreach/contacts?list=&status=&source=&tag=&q=` (design outreach-v2 k1). */
const ContactsViewComponent: React.FC = () => {
  const accountId = useAccountId();
  const [searchParams] = useSearchParams();
  if (accountId === null) {
    return <LoadingView />;
  }
  const status = STATUSES.find((value) => value === searchParams.get('status')) ?? null;
  return (
    <ContactsScreen
      accountId={accountId}
      initialFilters={{
        listUuid: searchParams.get('list'),
        status,
        tag: searchParams.get('tag'),
        q: searchParams.get('q') ?? '',
        source: searchParams.get('source') === 'imported' ? 'imported' : null,
        kind: null,
      }}
    />
  );
};

export const ContactsView = TypedMemo(ContactsViewComponent);
